import script from "./Qualifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./Qualifications.vue?vue&type=script&setup=true&lang=ts"

import "./Qualifications.vue?vue&type=style&index=0&id=2f96bf96&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f96bf96"]])

export default __exports__